import { render, staticRenderFns } from "./SendMessageChannelMenu.vue?vue&type=template&id=134c654e&scoped=true"
import script from "./SendMessageChannelMenu.vue?vue&type=script&lang=js"
export * from "./SendMessageChannelMenu.vue?vue&type=script&lang=js"
import style0 from "./SendMessageChannelMenu.vue?vue&type=style&index=0&id=134c654e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c654e",
  null
  
)

export default component.exports